import { css } from '@emotion/css';
import { Tooltip } from 'antd';
import type React from 'react';
import { useRef, useState } from 'react';

const ellipsis = css`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AutoTitle: React.FC<{ content: string | undefined }> = ({ content }) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [title, setTitle] = useState<string | undefined>();

  if (!content) {
    return null;
  }

  return (
    <Tooltip title={title} trigger={['hover', 'click']}>
      <span
        className={ellipsis}
        ref={ref}
        onMouseEnter={() => {
          const node = ref.current;
          if (!node) return;
          setTitle(node.offsetWidth < node.scrollWidth ? content : undefined);
        }}
      >
        {content}
      </span>
    </Tooltip>
  );
};
